var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cu-title"},[_c('div',{on:{"click":_vm.toggleShrink}},[_c('svg-icon',{staticClass:"expen-con",attrs:{"icon-class":"view-list"}})],1),_c('div',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.getTitle))]),_c('div',{staticClass:"sub"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }